import { TemplatePage } from './types';

const live_streaming_trn_lower_third_page: TemplatePage = {
  header: {
    color: '#DDDCD7',
    icon: 'images/video-templates/transp_lower_third.jpg',
    title: 'Transparent Lower Third Templates',
    title_meta: '20+ Free Transparent Lower Third Templates',
    description_meta:
      'Design stylish lower third on transparent background with Wave.video’s free and easily customizable templates. ' +
      'Export the overlay as a .png, .gif, or mp4 file.',
    description:
      'Give your live streams a professional look with a branded lower third. Pick a template that matches your ' +
      'style and replace the default overlays with your logo, photo, and text. Publish it as a video, save any frame a' +
      's a static .png image, or export it as a GIF.'
  },
  footer: {
    category: 'Live streaming transparent lower third',
    description:
      'With Wave.video’s collection of editable templates, you can make a custom lower third for any multistreaming ' +
      'platform, including StreamYard, Restream, Be.live, and many more. Don’t overlook the importance of stream graphics ' +
      'for your broadcasts. Create an eye-catching branded lower third on a transparent background to impress your viewers ' +
      'and enhance your brand recognition.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming transparent lower third',
      search: { name: 'LiveLowerThird', tags: 'LiveLowerThird' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_trn_lower_third_page;
